/**
 * Component Registry for Wind River Lodge Apartments & Townhomes
 * 
 * Inherits from @vibesites-price-brothers/theme-vantage and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-vantage/registry';
import { ContactForm } from './components/ContactForm';
import { FloorplansList } from './components/FloorplansList';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { NeighborhoodSection } from './components/NeighborhoodSection';
import { PreferredEmployerCTA } from './components/PreferredEmployerCTA';
import { PropertyOverview } from './components/PropertyOverview';
import { ScheduleTourForm } from './components/ScheduleTourForm';
import { SisterProperties } from './components/SisterProperties';
import { SpecialOfferBanner } from './components/SpecialOfferBanner';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Installs primary CTA sheen styles on every page (banner remains a no-op).
  SpecialOfferBanner,
  // Form submit CTAs use primary instead of parent secondary.
  ContactForm,
  ScheduleTourForm,
  // Geometric pattern background for the floor plans section (from main).
  FloorplansList,
  // Nav reads the site's merged pages so site-level visibility toggles apply.
  Header,
  // Full-bleed image slider hero (matches windriverlodgeapts.com).
  Hero,
  // Section titles use primary brand color.
  PropertyOverview,
  NeighborhoodSection,
  // Apply Now CTA uses secondary on the primary band.
  PreferredEmployerCTA,
  // Sister cards generate by closest company community distance.
  SisterProperties,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
